import "./bootstrap";
import Alpine from 'alpinejs'
import './header'

import './home'

window.Alpine = Alpine
 
Alpine.start()


window.addEventListener('popstate', () => {
  window.dispatchEvent(new Event('locationchange'));
});
